import { useState } from 'react';
import { fetchMiniappRestartUrl } from './api.js';
import type { MaxWebApp } from './max.js';

export function ExpiredSessionNotice({ webApp, className }: { webApp?: MaxWebApp; className: string }) {
  const [restarting, setRestarting] = useState(false);
  const [error, setError] = useState('');

  const restart = async () => {
    setRestarting(true);
    setError('');
    try {
      const result = await fetchMiniappRestartUrl();
      if (!result.ok || !result.url) throw new Error('RESTART_URL_UNAVAILABLE');
      if (webApp?.openMaxLink) webApp.openMaxLink(result.url);
      else window.location.assign(result.url);
    } catch {
      setError('Не удалось обновить сессию. Закройте мини-приложение и откройте его заново из MAX.');
      setRestarting(false);
    }
  };

  return <div className={className} role="alert">
    <span>Сессия мини-приложения устарела. Обновите её, чтобы продолжить. Повторно делиться номером не нужно.</span>
    <button type="button" disabled={restarting} onClick={() => void restart()}>
      {restarting ? 'Обновляем…' : 'Обновить'}
    </button>
    {error ? <span>{error}</span> : null}
  </div>;
}
